// «Текст пункта» под пунктом ответа по праву со ссылкой на постановление Пленума Верховного Суда или обзор его
// практики (kind = "overview"): раздел, пункт целиком и весь документ из базы Правосвода (GET /api/plenum/<id>).
// Загружается только при раскрытии.
import { useState } from "react";
import { getJson } from "../api";

type Point = {
  id: string; label: string; title: string; section: string; checked: string; text: string; act: string; url: string;
  kind?: "plenum" | "overview";
};

export function isExplanation(sourceId: string | undefined): boolean {
  return !!sourceId && sourceId.startsWith("vs:");
}

// Текст с КонсультантПлюс сверен по действующей редакции («03.11.2026 по КонсультантПлюс (ред. от …)»), файл с сайта
// Верховного Суда скачан человеком («03.11.2026 с vsrf.ru»).
export function plenumChecked(checked: string): string {
  return checked.includes("vsrf.ru") ? "текст скачан" : "текст сверен";
}

// «Весь текст постановления» под пунктом Пленума в разборе документа: постановление из базы — по раскрытии.
export function PlenumAct({ id }: { id: string }) {
  const [act, setAct] = useState("");
  const [error, setError] = useState("");
  function load(open: boolean) {
    if (!open || act || error) return;
    getJson<Point>(`/api/plenum/${encodeURIComponent(id)}`).then((point) => setAct(point.act))
      .catch((failure) => setError((failure as Error).message));
  }
  return (
    <details className="norm-full norm-act" onToggle={(event) => load((event.currentTarget as HTMLDetailsElement).open)}>
      <summary>Весь текст постановления</summary>
      {error ? <p className="msg-error">{error}</p> : act ? <blockquote>{act}</blockquote> : <p className="msg-hint">Загружаю…</p>}
    </details>
  );
}

export function PlenumText({ id }: { id: string }) {
  const [point, setPoint] = useState<Point | null>(null);
  const [error, setError] = useState("");
  function load(open: boolean) {
    if (!open || point || error) return;
    getJson<Point>(`/api/plenum/${encodeURIComponent(id)}`).then(setPoint).catch((failure) => setError((failure as Error).message));
  }
  return (
    <details className="assistant-article" onToggle={(event) => load((event.currentTarget as HTMLDetailsElement).open)}>
      <summary>Текст пункта</summary>
      {error ? <p className="msg-error">{error}</p> : !point ? <p className="msg-hint">Загружаю…</p> : (
        <>
          {point.section ? <p className="decision-subject">{point.section}</p> : null}
          <blockquote>{point.text}</blockquote>
          <details className="decision-full">
            <summary>{point.kind === "overview" ? "Весь текст обзора" : "Весь текст постановления"}</summary>
            <blockquote>{point.act}</blockquote>
          </details>
          {point.url ? (
            <p className="msg-hint">
              {point.title}. Текст сверен {point.checked}.{" "}
              <a href={point.url} target="_blank" rel="noreferrer">Текст на КонсультантПлюс</a>
            </p>
          ) : <p className="msg-hint">{point.title}. Текст с сайта Верховного Суда, скачан {point.checked}.</p>}
        </>
      )}
    </details>
  );
}
